import { Component, OnInit, inject } from '@angular/core';
import { ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { Allergy } from '@xmedical/core';

// Pure dialog content — returns an allergy value via dialogRef.close().
// The opener (allergies-widget) persists via AllergiesRepositoryService.
@Component({
  selector: 'xcs-allergy-add-card',
  templateUrl: './allergy-add-card.component.html',
  styleUrl: './allergy-add-card.component.scss',
  imports: [
    ReactiveFormsModule,
    MatButtonModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
  ],
})
export class AllergyAddCardComponent implements OnInit {

  private dialogRef = inject<MatDialogRef<AllergyAddCardComponent>>(MatDialogRef);
  private formBuilder = inject(UntypedFormBuilder);

  validate = false;
  form: UntypedFormGroup | null = null;

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      allergy: ['', Validators.required],
    });
  }

  save(): void {
    if (!this.form) return;
    if (this.form.valid) {
      this.dialogRef.close(this.form.value as Allergy);
    }
    this.validate = true;
  }

  close(): void {
    this.dialogRef.close();
  }
}
